import {
  CheckArgumentsTemplateListView,
  type CheckArgumentsTemplateListConfig,
} from "../check-arguments-templates-shared";

const config: CheckArgumentsTemplateListConfig = {
  listApiPath:
    "/api/internal/client-portal/check-arguments-templates/directorship/",
  settingsPathPrefix: "directorship-templates",
  pageTitle: (t) => t("Directorship"),
  testIdPrefix: "directorship-template",
  apiPathPrefix: "directorship",
  filterBarTestId: "directorship",
};

export const DirectorshipTemplateListView =
  CheckArgumentsTemplateListView(config);
